import http from "./HttpService";
import config from "../config.json";

export const getWfPhasesBgColor = (phase) => {
  // eslint-disable-next-line default-case
  switch (phase) {
    case "Closed":
      return "default text-white";
    case "Review":
      return "yellow text-dark";
    case "Application":
      return "primary text-white";
    case "Pending":
      return "info text-dark";
    case "Approved":
      return "success text-white";
    case "Denied":
      return "danger text-white";
    case "Withdrawn":
      return "warning text-white";
  }
};

export const getWfPhasesColor = (phase) => {
  switch (phase) {
    case "Closed":
      return "btn-default";
    case "Review":
      return "btn-wf2-default";
    case "Onboarding":
      return "btn-wf2-default";
    case "Application":
      return "btn-primary";
    case "Pending":
      return "btn-info";
    case "Approved":
      return "btn-wf3-default";
    case "Denied":
      return "btn-wf4-default";
    case "Withdrawn":
      return "btn-warning";
    case "Compliance":
      return "btn-wf5-default";
    case "Time Log":
      return "btn-wf6-default";
    case "Invoice":
      return "btn-wf6-default";
    default:
      return "btn-wf-default";
  }
};

export const getFieldData = (aWorkfinityApp, attribue, filedName) => {
  if (!aWorkfinityApp || aWorkfinityApp === "undefined") return "";
  try {
    const appEntity = JSON.parse(aWorkfinityApp);
    if (!appEntity) return "";
    const appShortName = Object.keys(appEntity)[1];
    if (!appShortName) return "";
    const aWorkfinityAppEntity = appEntity[appShortName];
    if (!aWorkfinityAppEntity) return "";
    const obj = aWorkfinityAppEntity[attribue];
    if (!obj) return "";
    if (!obj["@" + filedName]) return "";
    return obj["@" + filedName];
  } catch (e) {
    console.error("Error in getFieldData parsing: ", e);
    return "";
  }
};

export const getFormatedNumber = (number) => {
  if (!number) return;
  return (
    number?.slice(0, 3) + "-" + number?.slice(3, 6) + "-" + number?.slice(6)
  );
};

export const formatSSNNumber = (value) => {
  if (!value) return value;
  let phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 6) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    5
  )}-${phoneNumber.slice(5)}`;
};

export const formatPhoneNumber = (value) => {
  if (!value) return value;
  let phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6)}`;
};

export const getAddressGroup = () => {
  const group = [
    "apistatecountycity",
    "apistatecounty",
    "apicountrystate",
    "apiuscountycity",
    "apiusstatecounty",
    "apicountrystatecountycity",
  ];
  return group;
};

export const getAllYears = () => {
  const years = [];
  for (let index = 1; index < 36; index++) {
    const element = { id: index, name: 2022 + index };
    years.push(element);
  }
  return years;
};

export const getMonthName = (num) => {
  switch (num) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Aug";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";
    default:
      return "";
  }
};

export const getAllMonths = () => {
  const months = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];
  return months;
};

export const getTotalHours = (hrs) => {
  if (!hrs) return 0;
  const wt = JSON.parse(hrs);

  let totalMinutes = 0;

  wt.filter((x) => x.title !== null).forEach((t) => {
    const parts = t.title.toString().split(".");
    const hours = parseInt(parts[0] || 0);
    const minutes = parseInt(parts[1] || 0);

    totalMinutes += hours * 60 + minutes;
  });

  const totalHoursDecimal = totalMinutes / 60;

  return parseFloat(totalHoursDecimal.toFixed(2));
};

export const formatTotalHours = (hrs) => {
  if (!hrs) return "0h 0m";

  let wt;
  try {
    wt = JSON.parse(hrs);
  } catch {
    return "0h 0m";
  }

  let totalMinutes = 0;

  wt.filter((x) => x.title !== null).forEach((t) => {
    const parts = t.title.toString().split(".");
    const hours = parseInt(parts[0] || 0);
    const minutes = parseInt(parts[1] || 0);
    totalMinutes += hours * 60 + minutes;
  });

  const finalHours = Math.floor(totalMinutes / 60);
  const finalMinutes = totalMinutes % 60;

  return `${finalHours}h ${finalMinutes}m`;
};

export const getTotalDays = (hrs) => {
  if (!hrs) return 0;

  let wt;
  try {
    wt = JSON.parse(hrs);
  } catch (e) {
    return 0;
  }

  if (!Array.isArray(wt) || wt.length === 0) return 0;

  // Count non-monthly days (type ≠ "m")
  const dayEntries = wt.filter((x) => x?.title !== null && x?.type !== "m");

  const dayCount = dayEntries.length;

  // If no day-by-day entries, use "m" (monthly) entry
  if (dayCount === 0) {
    const monthEntry = wt.find((x) => x?.title !== null && x?.type === "m");
    return monthEntry?.days ?? 0;
  }

  return dayCount;
};

export const getMonthLastDay = (d) => {
  const dt = new Date(d);
  return new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
};

export const toLocalDate = (str) => {
  const [y, m, d] = getDateOnly(str)?.split("-").map(Number);
  return new Date(y, m - 1, d); // LOCAL date (no timezone shift)
};

/**
 * Return local YYYY-MM-DD from any date or datetime string.
 * This avoids timezone shifting completely.
 */
export const getDateOnly = (d) => {
  if (!d) return d;

  // If input already date-only, avoid UTC parsing
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
    return d; // already safe
  }

  const date = new Date(d);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

/**
 * Convert a single event to timezone-proof format.
 */
export const sanitizeEvent = (e) => {
  return {
    ...e,
    start: getDateOnly(e.start),
    end: getDateOnly(e.end),
  };
};

/**
 * Convert list of events (any format) to safe calendar format.
 */
export const sanitizeEventList = (events) => {
  return events.map((e) => sanitizeEvent(e));
};

export const formatAmount = (value) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseFloat(value) || 0);

const dropdownCache = {};

export const getDropdownCodemanager = async (attribute, attObject) => {
  const cacheKey = `${attribute.toLowerCase()}_${attObject}`;
  if (dropdownCache[cacheKey]) {
    return dropdownCache[cacheKey];
  }
  const { data: items } = await http.get(
    config.GetDataTypeCodemanager +
      attribute.toLowerCase() +
      "&att=" +
      attObject
  );
  dropdownCache[cacheKey] = items;
  return items;
};

export const getSubformDatatypes = async (attribute, attObject) => {
  const { data } = await http.get(
    config.GetDataType + attribute + "&attName=" + attObject
  );
  return data;
};
